import { render, staticRenderFns } from "./registrationFormListing.vue?vue&type=template&id=68e56a5c"
import script from "./registrationFormListing.vue?vue&type=script&lang=js"
export * from "./registrationFormListing.vue?vue&type=script&lang=js"
import style0 from "./registrationFormListing.vue?vue&type=style&index=0&id=68e56a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports